/* ──────────────────────────────────────────────────────────────────────────
 * INIT series: Initialization / Bootstrapping / session lifecycle errors
 * ────────────────────────────────────────────────────────────────────────── */
export const INIT_ERROR_CODES = {
  SERVICE_FAILED: 'CLIENTOS_INIT_001',
  CRITICAL_SERVICES_FAILED: 'CLIENTOS_INIT_002',
  BEFORE_BEHAVIORS_FAILED: 'CLIENTOS_INIT_003',
  SECONDARY_SERVICES_FAILED: 'CLIENTOS_INIT_004',
  POST_SETUP_FAILED: 'CLIENTOS_INIT_005',
  TOKEN_REHYDRATION_AUTH_ERROR: 'CLIENTOS_INIT_006',
  TOKEN_CACHE_REHYDRATION_FAILED: 'CLIENTOS_INIT_007'
} as const;
